export class NoCodesError {
    constructor(code, description, additionalMessage, domain, error) {
        this.code = code;
        this.domain = domain;
        this.description = description;
        this.additionalMessage = additionalMessage;
        this.error = error;
    }
}
//# sourceMappingURL=NoCodesError.js.map